import React, { Component } from 'react';
import './header.css';
import axios from 'axios';

import { BrowserRouter, Route, Link } from 'react-router-dom';


function Header (props){
  var profile;
  var logout;
  var id=props.id;
  if (id !== ""){
    profile=(<li  className="nav-links--profile"><button><Link to="/profile">Profile</Link></button></li>);
    logout=(<li  className="nav-links--logout"><button onClick={props.logout}>Logout</button></li>);
  }
  else {logout=(<li  className="nav-links--login"><button onClick={props.login}>Login</button></li>)}
  return(
    <div className="layout-header"><nav className="main-nav">
      <ul className="nav-links">
        <li  className="nav-links--home"><button><Link to="/">Home</Link></button></li>
        <li className="nav-links--about"><button><Link to="about">About</Link></button></li>
        <li className="nav-links--letsGo"><button><Link to="letsGo">Get Started</Link></button></li>
        {profile}
        {logout}
      </ul>
      <div className="main-logo-holder"></div>
    </nav></div>
  )}



export default Header;



// WEBPACK FOOTER //
// ./src/header.js